import con from '../../../../../connection';
var path = '/address';
var address = function (url) { return function () {
    return {
        get: function () { return con.get(url + path, {}); },
    };
}; };
export default address;
